import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DialogContent from "@mui/material/DialogContent";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
    IOptions,
    SelectedProductFakturKonsinyasi,
} from "../../constants/types";
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Box from "@mui/material/Box";
import PilihBarangStep from "./PilihBarangStep/PilihBarangStep";
import DetailBarangStep from "./DetailBarangStep/DetailBarangStep";
import Button from "@mui/material/Button";

interface IModalFakturKonsinyasiProps {
    isOpenModalFakturKonsinyasi: boolean;
    closeModalFakturKonsinyasi: () => void;
    isPO?: boolean;
}

const ModalFakturKonsinyasi = ({
    isOpenModalFakturKonsinyasi,
    closeModalFakturKonsinyasi,
    isPO,
}: IModalFakturKonsinyasiProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "sm"));
    const [activeStep, setActiveStep] = useState(0);
    const [products, setProducts] = useState<SelectedProductFakturKonsinyasi[]>(
        [],
    );
    const [detailId, setDetailId] = useState<number>();

    const addDetailId = (id: number) => {
        setDetailId(id);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        if (activeStep === 1) {
            setProducts([]);
        }
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const addProducts = (item: SelectedProductFakturKonsinyasi[]) => {
        setProducts(item);
    };

    const resetBundlingSteps = () => {
        setActiveStep(0);
        setProducts([]);
    };

    const steps = [
        {
            label: "Pilih produk",
            description: `Anda dapat memilih produk lebih dari satu yang ingin anda masukkan ke dalam faktur.`,
        },
        {
            label: "Atur faktur konsinyasi",
            description:
                "Atur faktur konsinyasi untuk setiap stok barang yang anda pilih.",
        },
    ];

    useEffect(() => {
        if (!isOpenModalFakturKonsinyasi) {
            resetBundlingSteps();
        }
    }, [isOpenModalFakturKonsinyasi]);

    // console.log('products', products);

    return (
        <Dialog
            maxWidth="md"
            fullScreen={isPhoneScreen}
            fullWidth={true}
            open={isOpenModalFakturKonsinyasi}
            onClose={() => {}}
            scroll="body"
            PaperProps={{
                sx: {
                    borderRadius: 1,
                },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton onClick={closeModalFakturKonsinyasi}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        {isPO ? "Pemesanan Konsinyasi" : "Faktur Konsinyasi"}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent dividers>
                <React.Fragment>
                    <Grid>
                        <Stepper activeStep={activeStep} orientation="vertical">
                            {steps.map((step, index) => (
                                <Step key={String(index + 1)}>
                                    <StepLabel>{step.label}</StepLabel>
                                    <StepContent>
                                        <Typography color="GrayText">
                                            {step.description}
                                        </Typography>
                                        <Box my={4}>
                                            {index === 0 && (
                                                <React.Fragment>
                                                    <PilihBarangStep
                                                        addProducts={
                                                            addProducts
                                                        }
                                                        addDetailId={
                                                            addDetailId
                                                        }
                                                    />
                                                    <Box
                                                        mt={4}
                                                        display="grid"
                                                        gridTemplateColumns="1fr 1fr 1fr"
                                                        justifyContent="flex-end"
                                                        columnGap="16px"
                                                    >
                                                        <div />
                                                        <Button
                                                            disabled={
                                                                index === 0
                                                            }
                                                            onClick={handleBack}
                                                            variant="outlined"
                                                        >
                                                            Kembali
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            disabled={
                                                                activeStep ===
                                                                    0 &&
                                                                products.length ===
                                                                    0
                                                            }
                                                            onClick={handleNext}
                                                        >
                                                            Lanjutkan
                                                        </Button>
                                                    </Box>
                                                </React.Fragment>
                                            )}
                                            {index === 1 && (
                                                <DetailBarangStep
                                                    products={products}
                                                    onBack={handleBack}
                                                    isOpenModalFakturKonsinyasi={
                                                        isOpenModalFakturKonsinyasi
                                                    }
                                                    closeModalFakturKonsinyasi={
                                                        closeModalFakturKonsinyasi
                                                    }
                                                    detailId={detailId ?? 99999}
                                                    isPO={isPO}
                                                />
                                            )}
                                        </Box>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper>
                    </Grid>
                </React.Fragment>
            </DialogContent>
        </Dialog>
    );
};

export default ModalFakturKonsinyasi;
